// 封装一个公共的 HTTP 请求类
import BaseService from "@/api/base";

class NativeService extends BaseService {
    // 基础的 API 地址
    private get_area_path = "https://restapi.amap.com/v3/ip"
    private get_weather_path = "https://restapi.amap.com/v3/weather/weatherInfo"

    private run_time_path = "/1password/api/v1/serve/run_time"
    private statistics_path = "/1password/api/v1/serve/statistics"

    // 封装 GET 请求方法
    public async getArea(): Promise<any> {
        return await this.getFetchDataNoCheck(this.get_area_path, {key:'f6095b7db30ef47054851299d2c000ff'});
    }

    public async getWeather(query:any): Promise<any> {
        query.key='f6095b7db30ef47054851299d2c000ff';
        query.extensions='base';
        return await this.getFetchDataNoCheck(this.get_weather_path, query);
    }

    public async runTime(): Promise<any> {
        return await this.getFetchDataNoCheck(this.run_time_path, {});
    }

    public async statistics(): Promise<any> {
        return await this.getFetchDataNoCheck(this.statistics_path, {});
    }


}

export default NativeService;
